/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useEffect, useState } from 'react';

import {
  Button,
  Card,
  Container,
  Col,
  Row,
  Table
} from 'react-bootstrap';
import moment from 'moment';

import { getFiveReservations } from 'apis/admin/reservationApi';
import { getRecentQnAList } from 'apis/admin/qnaApi';

import SimpleHeader from 'components/Headers/SimpleHeader';

function Dashboard(props) {
  const [recentReservations, setRecentReservations] = useState([]);
  const [recentQna, setRecentQna] = useState([]);

  const getList = async () => {
    await getFiveReservations()
      .then((response) => {
        if (response.data.success) {
          setRecentReservations(response.data.result);
        }
      })
      .catch(() => {});
      
    await getRecentQnAList()
      .then((response) => {
        if (response.data.success) {
          setRecentQna(response.data.result);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <SimpleHeader parentName="홈" name="대시보드" />
      <Container className="mt--6" fluid>
        <Row>
          <Col xl={6}>
            <Card>
              <Card.Header className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">최근 예약 내역</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      variant="primary"
                      onClick={() => props.history.push('/admin/boards/reservation')}
                      size="sm"
                    >
                      상세 보기
                    </Button>
                  </div>
                </Row>
              </Card.Header>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">
                      성함
                    </th>
                    <th scope="col">
                      예약 날짜
                    </th>
                    <th scope="col">
                      예약 시간
                    </th>
                    <th scope="col">
                      연락처
                    </th>
                    <th scope="col">
                      참석 인원
                    </th>
                  </tr>
                </thead>
                <tbody className="list">
                  {recentReservations.length > 0 ? recentReservations.map((post, idx) => {
                    return (
                      <tr key={idx + post.reserved_date}>
                        <td>
                          {post.name}
                        </td>
                        <td>
                          {post.reserved_date}
                        </td>
                        <td>
                          {post.reserved_time}
                        </td>
                        <td>{(post.phone).replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)}</td>
                        <td>{post.how_many}명</td>
                      </tr>
                    );
                  }) : (
                    <tr>
                      <td colSpan={5} className="text-center text-muted">
                        데이터가 없습니다.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <Card>
              <Card.Header className="border-0">
                <Row className="align-items-center">
                  <div className="col">
                    <h3 className="mb-0">최근 문의 내역</h3>
                  </div>
                  <div className="col text-right">
                    <Button
                      variant="primary"
                      onClick={() => props.history.push('/admin/boards/qna')}
                      size="sm"
                    >
                      상세 보기
                    </Button>
                  </div>
                </Row>
              </Card.Header>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">
                      성함
                    </th>
                    <th scope="col">
                      연락처
                    </th>
                    <th scope="col">
                      유입 경로
                    </th>
                    <th scope="col">
                      문의 날짜
                    </th>
                  </tr>
                </thead>
                <tbody className="list">
                  {recentQna.length > 0 ? recentQna.map((qna, idx) => {
                    return (
                      <tr key={qna.id + idx}>
                        <td>
                          {qna.name}
                        </td>
                        <td>{qna.phone}</td>
                        <td>
                          {qna.funnel}
                        </td>
                        <td>{moment(qna.createdAt).format('YYYY[-]MM[-]DD')}</td>
                      </tr>
                    );
                  }) : (
                    <tr>
                      <td colSpan={4} className="text-center text-muted">
                        데이터가 없습니다.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Dashboard;
